import { type ValidateDocumentAdapter } from '../../validation/protocols/validate-document-adapter'
import { validatePhone } from 'validations-br'

export class PhoneValidatorAdapter implements ValidateDocumentAdapter {
  validate (value: string): boolean {
    return validatePhone(value)
  }
}
